import React from "react";
import { Thread } from "../types";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ThreadListProps {
  threads: Thread[];
  currentThreadId: string | null;
  onThreadSelect: (thread: Thread) => void;
  onNewThread: () => void;
  onDeleteThread: (threadId: string) => void;
}

const formatDate = (date: Date): string => {
  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

  if (diffInHours < 1) {
    return "Just now";
  } else if (diffInHours < 24) {
    return `${Math.floor(diffInHours)}h ago`;
  } else {
    return date.toLocaleDateString();
  }
};

export const ThreadList: React.FC<ThreadListProps> = ({
  threads,
  currentThreadId,
  onThreadSelect,
  onNewThread,
  onDeleteThread,
}) => {
  return (
    <div className='flex-1 overflow-y-auto'>
      <div className='p-4'>
        <Button onClick={onNewThread} className='w-full mb-4' variant='outline'>
          <Plus className='h-4 w-4 mr-2' />
          New Chat
        </Button>

        <div className='space-y-2'>
          {threads.map((thread) => (
            <div
              key={thread.id}
              className={`group relative p-3 rounded-lg cursor-pointer transition-colors ${
                currentThreadId === thread.id
                  ? "bg-primary/10 border border-primary/20"
                  : "hover:bg-muted/50"
              }`}
              onClick={() => onThreadSelect(thread)}
            >
              <div className='flex items-center'>
                <div className='flex-1 min-w-0'>
                  <div className='flex items-center justify-between'>
                    <h3 className='text-sm font-medium text-gray-900 dark:text-gray-100'>
                      {thread.name}
                    </h3>
                    <span className='text-xs text-gray-500 dark:text-gray-400'>
                      {formatDate(thread.updatedAt)}
                    </span>
                  </div>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteThread(thread.id);
                  }}
                  className='opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-100 dark:hover:bg-red-900/20 rounded'
                  title='Delete thread'
                >
                  <Trash2 className='h-4 w-4 text-red-500' />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
